import React, { useContext, useState } from "react";
import { IconDelete, IconMinus, IconPlus } from "../../../../assets/icons";
import LoaderDot from "../../../components/LoaderDot";
import { BasketHelper } from "../../../../core/utils/BasketHelper";
import ContextApp from "../../../../core/contexts/context.app";
function CounterButton({ totalCount, setTotalCount, item, size }) {
  //console.log("item=",item);
  // console.log("totalCount=",totalCount1);
  // const [totalCount, setTotalCount] = useState(1);
  const [loaderDot, setLoaderDot] = useState(false);
  const ctx = useContext(ContextApp);
  //تنظیمات برای باکس برای زمانی که میخواهیم سایز کوچک نمایش داده بشه
  let widthBox = "";
  let paddingYBox = "";
  let paddingStart = "";
  let paddingEnd = "";
  let mainWidth = "";
  let mainHeight = "";
  let svgClass = "";

  // دگمه افزایش تعداد بلیط
  const increment = (item) => {
    if (totalCount < 30) {
      setTotalCount(totalCount + 1);
    }
  };
  const decrement = (item) => {
    if (totalCount > 0) {
      setTotalCount(totalCount - 1);
    }
  };

  if (size == "sm") {
    widthBox = "100%";
    paddingYBox = " py-0 ";
    paddingStart = "ps-0  pe-1";
    paddingEnd = "pe-0 ps-1";
    mainWidth = "100%";
    mainHeight = "33px";
    svgClass = "small-svg";
  } else {
    widthBox = "52px";
    paddingYBox = "";
    paddingStart = " ";
    paddingEnd = " ";
    mainWidth = "fit-content";
    mainHeight = "";
    svgClass = "small-svg-1";
  }
  return (
    <div
      className={`${svgClass} border d-inline-block bg-white  d-flex align-items-center py-auto rounded-2`}
      style={{
        // height: "42px",
        width: mainWidth,
        height: mainHeight,
      }}
    >
      <button
        className={`btn  px-2 mx-0 btn-no-style ${paddingYBox} ${paddingEnd}`}
        onClick={() => increment(item)}
        disabled={loaderDot}
      >
        <IconPlus fillColor="#f80248" />
      </button>
      <span
        className="d-inline-block text-center fw-bold px-0 mb-1  position-relative h-100"
        style={{ width: widthBox }}
      >
        <div className=" mt-2 d-flex justify-content-center">
          {loaderDot ? (
            <LoaderDot />
          ) : (
            <span className="text-danger">{totalCount}</span>
          )}
        </div>
        {/* <div
          className=" fs-062 mb-1 text-black-06 position-absolute"
          style={{
            right: "50%",
            marginRight: "-27px",
            top: "69%",
            width: "50px",
          }}
        >
          تعداد بلیط
        </div> */}
      </span>

      <button
        className={` px-2 mx-0 btn btn-no-style  ${paddingYBox} ${paddingStart}`}
        onClick={() => decrement(item)}
        disabled={loaderDot}
      >
        {totalCount > 1 ? (
          <IconMinus fillColor="#f80248" />
        ) : (
          <IconMinus fillColor="#ccc" />
        )}
      </button>
    </div>
  );
}

export default CounterButton;
